import React from "react"
import { trim } from "lodash-es"

import { useTranslation } from "@/locales"
import Input from "../Input"
import InputAccount from "../InputAccount"

import styles from "./index.module.less"

interface Props {
    account: string
    password: string
    onChange: ({
        account,
        password,
    }: {
        account: string
        password: string
    }) => void
    onKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

const InputPassword: React.FC<Props> = (props) => {
    const { account, password, onChange, onKeyUp } = props
    const { t } = useTranslation()

    return (
        <>
            <InputAccount
                scene="account"
                value={account}
                onChange={(val) => {
                    onChange({ account: val, password })
                }}
                onKeyUp={onKeyUp}
            />
            <Input
                type="password"
                autoComplete="off"
                className={styles.pwd}
                value={password}
                onChange={(e) =>
                    onChange({ account, password: trim(e.target.value) })
                }
                onKeyUp={onKeyUp}
                placeholder={t("login.placeholder.password")}
            />
        </>
    )
}

export default InputPassword
